import React from 'react';

import ChildrenPropType from 'lib/CustomPropTypes/children';

function Column(props) {
  const { children } = props;

  return (
    <div className="today-cover-tabbed__column">
      { children }
    </div>
  );
}

Column.propTypes = {
  children: ChildrenPropType.isRequired,
};

export default Column;
